export default {
  unmask: true,
  mask: /^\S*@?\S*$/,
};
